export const LoginForm = {
  Username: "",
  Password: "",
};
